import { Component, OnInit, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrl: './avatar.component.scss',
    standalone: true,
    imports: [NgStyle]
})
export class AvatarComponent implements OnInit {

    @Input()
    public photoUrl: string = "";

    @Input()
    public FirstName: string = "";
    @Input()
    public LastName: string = "";
    @Input()
    public IsBold: boolean = false;

    public showInitials = false;
    public initials: string = "";
    public circleColor?: string;

    private colors = [
        '#EB7181', // red
        '#468547', // green
        '#FFD558', // yellow
        '#3670B2', // blue,

    ];

    ngOnInit() {

        if (!this.photoUrl) {
            this.showInitials = true;
            this.createInititals();
        }
    }

    private createInititals(): void {
        let initials = "";
        let total: number = 0;

        initials = this.FirstName.toLocaleUpperCase().charAt(0) + this.LastName.toLocaleUpperCase().charAt(0)
        total = this.FirstName.toLocaleUpperCase().charCodeAt(0) - 65 + this.LastName.toLocaleUpperCase().charCodeAt(0) - 65 + this.FirstName.toLocaleUpperCase().charCodeAt(1) - 65 + this.LastName.toLocaleUpperCase().charCodeAt(1) - 65;

        total = Math.floor((total / (26 * 4) * 360 * 1000) % 1000) / 1000;

        this.circleColor = this.randomHSL(total);
        this.initials = initials;
    }

    randomHSL(v: number) {
        return `hsla(${~~(v * 360)}, 60%, 60%, 1)`
    }
}